import React from 'react';

import { SVGPropsType } from 'src/types';

function More(props: SVGPropsType) {
    const { fill, stroke, onClick, style, className } = props;

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path d="M4.8843 5H15.1158" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M9.74541 10H15.2547" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M4.8843 15H15.1158" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
            <path
                d="M4.63897 9.74563C4.45097 9.86313 4.45097 10.1369 4.63897 10.2544L7.10627 11.7965C7.30608 11.9214 7.56527 11.7777 7.56527 11.5421L7.56527 8.45797C7.56527 8.22234 7.30608 8.07868 7.10627 8.20357L4.63897 9.74563Z"
                fill={fill}
            />
        </svg>
    );
}

export default More;
